export default __webpack_public_path__ + "static/media/points.f2f4133e.svg";